/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import {
    useLocation,
    useNavigate,
    useParams
} from 'react-router-dom';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { useLegacyRouterParams } from '../contexts/LegacyRouterParams';
import { queryStringToParams } from 'Helpers/url';
import { getBaseName } from 'Constants/basename';
const withRouter = Component => {
    function ComponentWithRouterProp(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const rrParams = useParams();
        const legacyParams = useLegacyRouterParams();

        const history = {
            push: (...params) => navigate(...params),
            replace: (to, option) => {
                navigate(to, option || { replace: true });
            },
            goBack: () => navigate(-1),
            go: idx => navigate(idx)
        };
        const basename = getBaseName();
        const router = useMemo(() => {
            return {
                ...history,
                location: {
                    ...location,
                    query: location.search ? queryStringToParams(location.search.substring(1)) : {},
                    search: location.search || '',
                    ...(basename && { basename })
                },
                params: {
                    ...rrParams,
                    ...legacyParams
                },
                getCurrentLocation: () => location,
                navigate
            };
        }, [location]);

        return (
            <Component
                { ...props }
                params={ router.params }
                location={ router.location }
                router={ router }
            />
        );
    }

    ComponentWithRouterProp.displayName = `withRouter(${Component.displayName || Component.name})`;

    return hoistNonReactStatic(ComponentWithRouterProp, Component);
};

export default withRouter;
